// extracted by mini-css-extract-plugin
export default {"main":"examAnchor_main__u0rx6","item":"examAnchor_item__17+CC","active":"examAnchor_active__HLyCP"};